import React from 'react';
export default function IntroSection({item}) {
    if (!item) return null;

    return (
        <div className="culture-intro">
            <div className="culture-intro-text">
                <h2>{item.title || ''}</h2>
                <p>{item.short_description || ''}</p>
            </div>
            <div className="culture-intro-image">
                <img src={item.image_url || '/bw_image/default.png'} alt="Văn hóa TNH" />
            </div>
        </div>
    );
}
